import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/theme';
import { H2 } from '../../styles/stylesTypography';

export const Container = styled.div`
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: 32px 40px 96px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (max-width: 979px) {
        padding: 24px 20px 96px;
    }
`;

export const Secao = styled.section`
    background: ${theme.colors.gray.Cinza_13};
    border-radius: 20px;
    padding: 28px;

    @media (max-width: 760px) {
        padding: 20px;
    }
`;

export const SecaoHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
`;

/**
 * Cabeçalho do "Plano atual": título + status na mesma linha, descrição numa linha própria
 * ocupando a largura toda (flex-basis:100% força a quebra). É assim em qualquer largura -
 * abaixo de 479px muda só o alinhamento da 1a linha: título e status colados com gap pequeno
 * em vez de espalhados nas pontas (space-between), porque não sobra espaço lateral sobrando
 * pra justificar isso numa tela estreita.
 */
export const PlanoAtualHead = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;

    @media (max-width: 479px) {
        justify-content: flex-start;
        row-gap: 6px;
        column-gap: 10px;
    }
`;

export const PlanoAtualDescricao = styled.div`
    flex-basis: 100%;
`;

export const PlanoNomeTitulo = styled(H2)`
    @media (max-width: 479px) {
        font-size: 24px;
        line-height: 1.3;
    }
`;

export const Card = styled.div`
    background: ${theme.colors.white.Branco};
    border-radius: 12px;
    padding: 20px;
`;

export const GridDuas = styled.div`
    display: grid;
    grid-template-columns: ${props => props.single ? '1fr' : '1.1fr 0.9fr'};
    gap: 16px;

    @media (max-width: 979px) {
        grid-template-columns: 1fr;
    }
`;

export const PlanoMeta = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 18px;
`;

export const PlanoMetaLinha = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid ${theme.colors.gray.Cinza_12};
    padding-bottom: 8px;

    > *:first-child {
        min-width: 0;
        overflow-wrap: anywhere;
        text-align: left;
    }

    > *:last-child {
        flex-shrink: 0;
        text-align: right;
    }

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }
`;

export const AcoesPlano = styled.div`
    display: flex;
    gap: 12px;
    margin-top: 22px;
    flex-wrap: wrap;
`;

export const GaugeCard = styled(Card)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    text-align: center;
`;

export const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 500px;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    background: ${props => props.background || theme.colors.gray.Cinza_11};
    color: ${props => props.color || theme.colors.gray.Cinza_6};

    .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: currentColor;
    }
`;

export const Cartao = styled(Card)`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const BandeiraCartao = styled.div`
    min-width: 52px;
    height: 34px;
    padding: 0 8px;
    border-radius: 6px;
    background: ${theme.colors.gray.Cinza_1};
    display: grid;
    place-items: center;
    flex-shrink: 0;
    overflow: hidden;

    * {
        white-space: nowrap;
    }
`;

export const CobrancaInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const CobrancaLinha = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
`;

export const TabelaWrap = styled.div`
    background: ${theme.colors.white.Branco};
    border-radius: 12px;
    overflow: hidden;
    overflow-x: auto;
`;

export const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
`;

export const Th = styled.th`
    text-align: left;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${theme.colors.black.Preto};
    padding: 14px 24px;
    border-bottom: 1px solid ${theme.colors.gray.Cinza_11};
    white-space: nowrap;
`;

export const Td = styled.td`
    padding: 15px 24px;
    border-bottom: 1px solid ${theme.colors.gray.Cinza_12};
    white-space: nowrap;

    tr:last-child & {
        border-bottom: none;
    }
`;

export const FaturaLinks = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const FaturaDot = styled.span`
    display: flex;
    align-items: center;
    color: ${theme.colors.gray.Cinza_2};
`;

export const ZonaCancel = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
`;

export const ContainerModalGerenciar = styled.div`
   width: 100%;
   height: auto;

   gap: 16px;
   display: flex;
   flex-direction: column;
`;

export const ModalTexto = styled.p`
    font-size: 14px;
    color: ${theme.colors.gray.Cinza_6};
`;

export const Aviso = styled.div`
    background: ${props => props.erro ? theme.colors.red.fundo : theme.colors.yellow.fundo};
    border: 1px solid ${props => props.erro ? theme.colors.red.Vermelho_erro : theme.colors.yellow.Amarelo};
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 13px;
    color: ${props => props.erro ? theme.colors.red.Tostado : theme.colors.gray.Cinza_1};
    margin-bottom: 16px;
`;

export const Oferta = styled.div`
    background: ${theme.colors.gray.Cinza_13};
    border-radius: 12px;
    padding: 18px;
    display: flex;
    gap: 14px;
    align-items: flex-start;
    margin-bottom: 16px;
`;

export const OfertaPct = styled.div`
    background: ${theme.colors.green.Verde_AgroReceita};
    color: ${theme.colors.white.Branco};
    font-weight: 800;
    font-size: 14px;
    border-radius: 500px;
    padding: 8px 14px;
    flex-shrink: 0;
`;

export const MotivosLista = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
`;

export const MotivoLabel = styled.label`
    display: flex;
    gap: 10px;
    align-items: center;
    border: 1px solid ${props => props.checked ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_10};
    background: ${props => props.checked ? theme.colors.green.Fundo : 'transparent'};
    border-radius: 500px;
    padding: 11px 18px;
    font-size: 13px;
    cursor: pointer;

    input {
        accent-color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

export const PerdaLista = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 13px;
    color: ${theme.colors.gray.Cinza_6};
    margin-bottom: 16px;

    li {
        display: flex;
        gap: 10px;
        align-items: flex-start;
    }
`;

export const CampoTexto = styled.textarea`
    width: 100%;
    border: 1px solid ${theme.colors.gray.Cinza_10};
    border-radius: 8px;
    padding: 11px 16px;
    font-family: 'Lato', sans-serif;
    font-size: 13px;
    color: ${theme.colors.gray.Cinza_2};
    resize: vertical;
    min-height: 64px;

    &:focus {
        outline: none;
        border-color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

export const Rotulo = styled.span`
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${theme.colors.gray.Cinza_6};
    margin-bottom: 6px;
    display: block;
`;

export const FormaPagamentoOpcoes = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    > div {
        flex: 1;
        min-width: 130px;

        > div {
            width: 100%;
            padding: 14px 12px;
        }
    }
`;

export const FormaPagamentoLabel = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const CamposCartaoGrid = styled.div`
    display: grid;
    grid-template-columns: ${props => props.duasColunas ? '1fr 1fr' : '1fr'};
    gap: 14px;
`;

export const LinkAcao = styled.button`
    all: unset;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ModalFootRow = styled.div`
    width: ${props => props.spaced ? '100%' : 'auto'};
    padding-top: 18px;
    
    gap: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    
    border-top: 1px solid #E9ECF0;
`;

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: .4; }
    100% { opacity: 1; }
`;

export const Skeleton = styled.div`
    width: ${props => props.width || '100%'};
    height: ${props => props.height || '14px'};
    border-radius: ${props => props.radius || '6px'};
    background: ${theme.colors.gray.Cinza_11};
    animation: ${pulse} 1.4s ease-in-out infinite;
`;

export const SkeletonLinha = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid ${theme.colors.gray.Cinza_12};
    padding-bottom: 8px;

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }
`;
